import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const MissionVisionPage = () => {
  return (
    <>
      <Header />

      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">

              {/* HERO SIMPLE */}
              <section className="pt-5 pb-2 text-center">
                <h1 className="fw-bold display-5 mb-3" style={{ color: "#A30003" }}>
                  Misión & Visión
                </h1>
                <p className="text-muted fs-5 mx-auto" style={{ maxWidth: "700px", color: "#A30003" }}>
                Construimos una marca local que conecta estilo, calidad y confianza en cada experiencia de compra.
                </p>
              </section>

              {/* MISIÓN */}
              <section className="py-4">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <h2 className="fw-semibold mb-4 border-bottom pb-3" style={{ color: "#A30003" }}>
                      Nuestra Misión
                    </h2>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Brindar a nuestros clientes prendas de calidad con una atención personalizada, facilitando una experiencia de compra cercana, 
                      confiable y alineada a sus necesidades de estilo.
                    </p>

                    <p className="fs-5 text-muted lh-lg mb-0" style={{ textAlign: "justify" }}>
                      Trabajamos cada día para ofrecer productos que generen confianza y satisfacción, 
                      entendiendo que cada cliente es parte fundamental de nuestro crecimiento.
                    </p>
                  </div>
                </div>
              </section>

              {/* VISIÓN */}
              <section className="pt-3 pb-5">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <h2 className="fw-semibold mb-4 border-bottom pb-3" style={{ color: "#A30003" }}>
                      Nuestra Visión
                    </h2>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Ser una marca de referencia a nivel local en moda, reconocida por su calidad, atención al cliente y compromiso con el estilo.
                    </p>

                    <p className="fs-5 text-muted lh-lg mb-0" style={{ textAlign: "justify" }}>
                      Buscamos consolidarnos como una opción confiable en el mercado, creciendo de manera sostenible y fortaleciendo la relación con nuestros clientes.
                    </p>

                  </div>
                </div>
              </section>

            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default MissionVisionPage;
